const LANGUAGE_NAME_TOKEN = "{language.name}";
const LANGUAGE_CODE_TOKEN = "{language.code}";
const LANGUAGE_ISO639_TOKEN = "{language.iso639}";
const CAPTION_TYPE_TOKEN = "{captionType}";
const TARGET_FILE_NAME_TOKEN = "{targetFileName}";
export const LANGUAGE_SPECIFICATION_TOKEN = "{languageSpec}";

export const subtitlesTargetFileNameTokens = [
    LANGUAGE_NAME_TOKEN,
    LANGUAGE_CODE_TOKEN,
    LANGUAGE_ISO639_TOKEN,
    CAPTION_TYPE_TOKEN,
    TARGET_FILE_NAME_TOKEN,
    LANGUAGE_SPECIFICATION_TOKEN
];

export const isTokenValid = (token: string): boolean => subtitlesTargetFileNameTokens.includes(token);
